<template>
  <v-container>
    <v-btn v-if="authPermissions.has('suppliers:create')" class="mx-2" tile dark large color="primary"
           @click="createSupplier = true">
      <v-icon left dark>
        mdi-account-multiple-plus
      </v-icon>
      Add Supplier
    </v-btn>
    <v-container v-if="authPermissions.has('suppliers:view')" class="mt-4">
      <v-card class="ma-0">
        <v-toolbar color="primary" dark>
          <v-card-title>Supplier Index</v-card-title>
        </v-toolbar>
        <index-supplier @editSupplier="initEditSupplier" />
      </v-card>
      <stock-cost-compare />
    </v-container>
    <!-- dialog -->
    <v-dialog v-model="editSupplier" dismissable max-width="600px" eager>
      <v-card style="-webkit-app-region: no-drag">
        <edit-supplier :prop-supplier-id="propSupplierData.id" :prop-supplier-data="propSupplierData"
                       @close-dialog="editSupplier = false" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="createSupplier" max-width="600px" style="-webkit-app-region: no-drag">
      <v-card class="pa-3" style="-webkit-app-region: no-drag">
        <v-card-title class="justify-start">
          ADD SUPPLIER
        </v-card-title>
        <create-supplier @close-dialog="createSupplier = false" />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'VSuppliers',
  components: {
    CreateSupplier: () => import('./../components/supplier/Create'),
    IndexSupplier: () => import('./../components/supplier/Index'),
    EditSupplier: () => import('./../components/supplier/Edit'),
    StockCostCompare: () => import('./../components/supplier/StockCostCompare.vue'),
  },
  data() {
    return {
      createSupplier: false,
      editSupplier: false,
      propSupplierData: {
        name: null,
        address: null,
        subscriptionDate: null,
        contactNo1: null,
        contactNo2: null,
      },
    }
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    initEditSupplier(supplierData) {
      this.editSupplier = true
      this.propSupplierData = supplierData
    },
  },
}
</script>
